<template>
  <span class="cursor-pointer hover:text-gray-800 mx-1" @click="bcFileStore.toggleView()">
    <aw-icon :icon="bcFileStore.view === 'table' ? 'grid' : 'list'" class="w-4 h-4 "></aw-icon>
  </span>
</template>

<script>
import { mapStores } from 'pinia'
import useBcFileStore from '@/frontapp/store/bcFile'

export default {
  computed: {
    ...mapStores(useBcFileStore),
  },
};
</script>

<style lang="scss" scoped></style>
